import {ActionType, CollapsesType} from 'constants/flow/flowTypes.js';
import {PRODUCT} from 'constants/actions';
import {COLLAPSE_TYPES} from 'constants/product';

export const initialState = {
    [COLLAPSE_TYPES.reviews]: false,
};

/**
 * Set collapsing state for collapsible block by name
 * @param {state} state - state
 * @param {action} action - action
 * @return {ActionType<{ name: string, collapsed: boolean }>} Action
 */
export default function collapses(
    state: CollapsesType = initialState,
    action: ActionType<{name: string; collapsed: boolean}>,
): CollapsesType {
    switch (action.type) {
        case PRODUCT.SET_COLLAPSE:
            return {...state, [action.payload.name]: action.payload.collapsed};
        default:
            return state;
    }
}
